export enum AuthErrors {
  NO_META_SUBJECT = 'Unable to find valid metaSubject',
  NO_PERMISSION_SUBJECT = 'Unable find valid permissonSubject',
  SUBJECT_MISMATCH = 'Subject Mismatch',
  INVALID_ENDPOINT = 'Permission Endpoint Didnt Match Endpoint',
  NO_GUID_SET = 'No GUID was found',
  GUEST_AUTH_FAILED = 'Guest Authentication Failed',
  UNEXPECTED_RESPONSE_FORMAT = 'Unexpected response format',

  // Permission Errros
  INSUFFICIENT_PERMISSIONS = 'Insufficient permissions',

  // Forbidden Errors -> For Authenticated Users who lack permissions
  PAGE_FORBIDDEN = 'You do not have permission to view this page',
  ACTION_FORBIDDEN = 'You do not have permission to perform this action',

  TOKEN_ALREADY_REFRESHING = 'TOKEN_ALREADY_REFRESHING',
  TOKEN_RENEWAL_CANCELLED = 'TOKEN_RENEWAL_CANCELLED',
}
